(() => {
  function init(scope=document) {
    scope.querySelectorAll('[data-review-topic]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const section = button.closest('.product-reviews');
        const details = section.querySelector('.write-review');
        const body = section.querySelector('textarea[name="contact[body]"]');
        if (!details || !body) return;
        details.open = true;
        body.placeholder = button.dataset.reviewTopic;
        body.focus({preventScroll:true});
        body.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
      });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in-view'); observer.unobserve(entry.target); }
      }), {threshold:0.12});
      scope.querySelectorAll('[data-soft-reveal]').forEach(el => {
        if (el.dataset.revealBound) return;
        el.dataset.revealBound = 'true';
        observer.observe(el);
      });
    }
    scope.querySelectorAll('[data-tabs]').forEach(group => {
      if (group.dataset.initialized) return; group.dataset.initialized = 'true';
      const tabs = [...group.querySelectorAll('[role="tab"]')].filter(tab => tab.closest('[data-tabs]') === group);
      const visibleTabs = () => tabs.filter(tab => getComputedStyle(tab).display !== 'none');
      function activate(tab, focus = false) {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
          const panel = group.querySelector('#' + CSS.escape(button.dataset.tab));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab?.focus();
      }
      function reset() {
        const visible = visibleTabs();
        activate(visible.find(tab => tab.getAttribute('aria-selected') === 'true') || visible[0]);
      }
      tabs.forEach(tab => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          const visible = visibleTabs(), index = visible.indexOf(tab);
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % visible.length;
          else if (event.key === 'ArrowLeft') next = (index + visible.length - 1) % visible.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = visible.length - 1;
          else return;
          event.preventDefault(); activate(visible[next], true);
        });
      });
      const media = matchMedia('(max-width: 760px)'); media.addEventListener('change', reset); reset();
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(group)) media.removeEventListener('change', reset); }, {once:true});
    });
    scope.querySelectorAll('.fit-checks').forEach(checks => {
      if (checks.dataset.initialized) return; checks.dataset.initialized = 'true';
      const update = () => {
        const inputs = [...checks.querySelectorAll('input')].filter(input => getComputedStyle(input.closest('label')).display !== 'none');
        const total = inputs.length, count = inputs.filter(input => input.checked).length;
        const result = checks.parentElement.querySelector('[data-fit-result]');
        if (result) result.textContent = total && count === total ? (checks.dataset.complete || 'All checked. Review your selected option above.') : count + ' of ' + total + ' checked. Take a moment with the details.';
      };
      checks.addEventListener('change', update);
      const media = matchMedia('(max-width: 760px)');
      media.addEventListener('change', update); update();
      document.addEventListener('shopify:section:unload', e => { if (e.target.contains(checks)) media.removeEventListener('change', update); }, {once:true});
    });
    scope.querySelectorAll('[data-return-situation]').forEach(select => {
      if (select.dataset.initialized) return; select.dataset.initialized = 'true';
      const media = matchMedia('(max-width: 760px)');
      const update = () => {
        const options = [...select.options];
        options.forEach(option => { const enabled = (media.matches ? option.dataset.showMobile : option.dataset.showDesktop) !== 'false'; option.hidden = !enabled; option.disabled = !enabled; });
        const enabled = options.filter(option => !option.disabled);
        if (!enabled.some(option => option.value === select.value)) select.value = enabled[0]?.value || '';
        select.closest('.returns-guide').hidden = enabled.length === 0;
        select.closest('.returns-control').querySelectorAll('[data-return-answer]').forEach(answer => { answer.hidden = answer.dataset.returnAnswer !== select.value; });
      };
      select.addEventListener('change', update); media.addEventListener('change', update); update();
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(select)) media.removeEventListener('change', update); }, {once:true});
    });
    scope.querySelectorAll('[data-review-scroll]').forEach(button=>{if(button.dataset.initialized)return;button.dataset.initialized='true';button.addEventListener('click',()=>{const carousel=button.closest('.product-reviews').querySelector('[data-review-carousel]');carousel?.scrollBy({left:Number(button.dataset.reviewScroll)*carousel.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});});
    scope.querySelectorAll('a[href="#WriteReview"]').forEach(link=>{if(link.dataset.initialized)return;link.dataset.initialized='true';link.addEventListener('click',()=>{const details=document.getElementById('WriteReview');if(details)details.open=true;});});
    if(location.hash==='#ProductReviewForm') { const review=document.getElementById('WriteReview');if(review)review.open=true; }
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
